import React, { Component } from 'react';
import { connect } from 'react-redux';
import { photosPrice, photos_url, directory, paypal } from '../config';
import Select from './Select';
import totalCartItems from './totalCartItems';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import { postCart, postCartAdmin } from '../actions/index';

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      images: this.props.cart,
      cart: this.props.cart,
      name: '',
      email: '',
      payment: '',
      address: '',
      total: totalCartItems(),
    };

    this.onChange = this.onChange.bind(this);
    this.onClickPhotoRemoveCart = this.onClickPhotoRemoveCart.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.onClickPhotoLessCart = this.onClickPhotoLessCart.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onClickPhotoRemoveCart(file) {
    const { images } = this.state;
    for (let i = 0; i < images.length; i++) {
      if (images[i].file === file) {
        images.splice(i, 1);
        this.setState({ images });
        break;
      }
    };
    localStorage.setItem('checkout', JSON.stringify(images));
  }

  addToCart(file) {
    const { images } = this.state;

    for (let i = 0; i < images.length; i++) {
      if (images[i].file === file) {
        images[i].qt = images[i].qt + 1;
        break;
      }
    }
    this.setState({ images });
    this.props.addToCart(file);
    localStorage.setItem('checkout', JSON.stringify(images));
  }

  onClickPhotoLessCart(file) {
    const { images } = this.state;

    for (let i = 0; i < images.length; i++) {
      if (images[i].file === file) {
        if (images[i].qt > 1) {
          images[i].qt = images[i].qt - 1;
        }
        break;
      }
    }
    this.setState({ images });
    this.props.onClickPhotoLessCart(file);
    localStorage.setItem('checkout', JSON.stringify(images));
  }

  onChange(e, photo) {
    const { images } = this.state;

    for (let i = 0; i < images.length; i++) {
      if (images[i].file === photo) {
        images[i].price = Number(e.target.value);
        images[i].size = e.target.selectedOptions[0].dataset.size;
        break;
      }
    }
    this.setState({ images });
    localStorage.setItem('checkout', JSON.stringify(images));
  }

  onChangeInput(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  returnPhotos() {
    const { images } = this.state;
    return images.map((photo, i) => {
      return (
        <div key={i} className="cart-item">
          <div className="image-qt">x {photo.qt}</div>
          <div className="image" style={{ backgroundImage: `url(${photos_url}/${directory}/images/thumbnails/${photo.file})` }}>
            <button type="button" className="cart-image-button" onClick={() => this.props.onClickPhotoCart(photo.file)}></button>
          </div>
          <div>
            <button type="button" className="remove-cart-image-button" onClick={() => this.onClickPhotoRemoveCart(photo.file)}>Apagar</button>
            <button type="button" className="more-cart-image-button" onClick={() => this.addToCart(photo.file)}>+</button>
            <button type="button" className="less-cart-image-button" onClick={() => this.onClickPhotoLessCart(photo.file)}>-</button>
          </div>
          <div className="size-cart">
            Tamanho:
            <Select
              options={photosPrice}
              onChange={this.onChange}
              value={photo.price}
              photo={photo}
            />
          </div>
        </div>
      )
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { email, address, name, payment, cart } = this.state;
    if (email && address && name && payment && JSON.parse(localStorage.checkout).length > 0) {
      const emailData = {
        data: {
          directory: directory,
          email,
          cart,
          address,
          name,
          payment,
          total: `€ ${totalCartItems()}`,
        }
      }
      this.props.postCartAdmin(emailData).then((data) => { debugger });
      this.props.postCart(emailData).then(() => {
        localStorage.setItem('checkout', '[]');
        this.setState({
          images: [],
          cart: [],
          name: '',
          email: '',
          payment: '',
          address: '',
        });
        alert('O seu pedido foi enviado com sucesso!');
      });
    } else {
      alert('Preencha todos os campos!');
    }

  }

  render() {
    const { email, address, name, payment, cart } = this.state;

    const onSuccess = (payment) => {
      const emailData = {
        email,
        cart,
        address,
        name,
        payment,
        total: totalCartItems() + 0.35 * 1.03,
      }

      this.props.postCart(emailData).then(() => {
        localStorage.setItem('checkout', '[]');
        this.setState({
          images: [],
          cart: [],
          name: '',
          email: '',
          payment: '',
          address: '',
        });
        alert('O seu pedido foi enviado com sucesso!');
      });
    }

    const onCancel = (data) => {

      // User pressed "cancel" or close Paypal's popup!
      console.log('The payment was cancelled!', data);
      // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
    }

    const onError = (err) => {
      debugger;
      // The main Paypal's script cannot be loaded or somethings block the loading of that script!
      console.log("Error!", err);
      // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
      // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    }

    let env = paypal.env; // you can set here to 'production' for production
    let currency = paypal.currency; // or you can set this value from your props or state
    let total = `${(+totalCartItems() * 1.03 + 0.35).toFixed(2)}`; // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
    // Document on Paypal's currency code: https://developer.paypal.com/docs/classic/api/currency_codes/



    const client = {
      sandbox: paypal.client.sandbox,
      production: paypal.client.production,
    }

    return (
      <div className="row checkout-form">
        <div className="col-sm-6">
          {this.state.images.length === 0 &&
            <h2>Ainda não adicionou fotos ao carrinho!</h2>
          }
          {this.returnPhotos()}
        </div>
        <div className="col-sm-6">
          <form>
            <div className="form-group">
              <label htmlFor="name">Nome completo</label>
              <input type="text" className="form-control" name="name" value={name} id="name" onChange={this.onChangeInput} />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" className="form-control" id="email" name="email" value={email} onChange={this.onChangeInput} />
            </div>
            <div className="form-group">
              <label htmlFor="address">Morada</label>
              <textarea autoComplete="false" className="form-control" name="address" value={address} id="address" rows="3" onChange={this.onChangeInput} />
            </div>
            <div className="form-group">
              <label htmlFor="address">Método de pagamento</label>
              <div className="form-check">
                <input className="form-check-input" type="radio" name="payment" id="payment-transf" value="transferencia" onChange={this.onChangeInput} />
                <label className="form-check-label" htmlFor="payment-transf">
                  Transferência bancária (os dados para pagamento serão enviados por email)
                </label>
              </div>
              {/* <div className="form-check">
                <input className="form-check-input" type="radio" name="payment" id="payment-paypal" value="paypal" onChange={this.onChangeInput} />
                <label className="form-check-label" htmlFor="payment-paypal">
                  Paypal / Cartão de crédito (Será cobrada uma taxa adicional de 0.35€ + 3%)
                </label>
              </div> */}
              <div className="form-check">
                <input className="form-check-input" type="radio" name="payment" id="MBWay" value="MBWay" onChange={this.onChangeInput} />
                <label className="form-check-label" htmlFor="MBWay">
                  MBWay (os dados para pagamento serão enviados por email)
                </label>
              </div>
            </div>
          </form>
          <div>
            {(this.state.images.length > 0 && payment === 'paypal' && email && address && name) &&
              <div className="text-center paypal-button">
                <PaypalExpressBtn env={env} client={client} currency={currency} total={total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />
              </div>
            }
            {(this.state.images.length > 0 && (payment === 'transferencia' || payment === 'MBWay') && email && address && name) &&
              <div className="text-center paypal-button">
                <button onClick={this.onSubmit} type="button" className="checkout-button">Finalizar</button>
              </div>
            }
          </div>
        </div>
        <div className="cart-footer text-center">
          Total: {totalCartItems()} €<br />
          <button onClick={this.props.payButton} type="button" className="pay-button">Finalizar encomenda</button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { checkoutCart: state.images.cart };
}

export default connect(mapStateToProps, { postCart, postCartAdmin })(Checkout);



// WEBPACK FOOTER //
// ./src/components/Checkout.js